import React, { AnchorHTMLAttributes, FC, ReactNode } from 'react';
import { gql } from '@apollo/client';
import Link from './Link';
import { LinkFieldFragment } from '../generated/graphql';

export const fragment = gql`
    fragment LinkField on LinkData {
        label
        target
        url
        type
        element {
            title
            uri
        }
    }
`;

interface Props extends AnchorHTMLAttributes<HTMLAnchorElement> {
    link: LinkFieldFragment;
}

const LinkField: FC<React.PropsWithChildren<Props>> = ({ link, title, children, ...rest }: Props) => {
    const { type, url, element, label } = link;
    let text: ReactNode = children ?? label ?? url;

    switch (type) {
        case 'entry':
            text = children ?? label ?? element?.title;
            return element?.uri ? (
                <Link href={`/${element.uri}`}>
                    <a target={link.target ?? undefined} {...rest}>
                        {text}
                    </a>
                </Link>
            ) : null;
        default:
            return url ? (
                <a href={url} target={link.target ?? undefined} {...rest} rel="noopener">
                    {text}
                </a>
            ) : null;
    }
};

export default LinkField;
